import gql from 'graphql-tag';
import { take, tap, pluck, withLatestFrom } from 'rxjs/operators';
import { BehaviorSubject } from 'rxjs';
import * as i0 from "@angular/core";
import * as i1 from "../shared/services/graph-qlclient.service";
import * as i2 from "apollo-angular/Apollo";
// * QUERY FILTRO Inventario
const QUERY_clientes_registros = gql `
query ($entidad: inventario_fisicoInputType, $paginaActual: Int, $cantidadRegistrosPorPagina: Int) {
  inventario_fisico {
    obtenerSegunFiltro(filtro: {exacto: $entidad}, paginaActual: $paginaActual, cantidadRegistrosPorPagina: $cantidadRegistrosPorPagina) {
      mensajes {
        codigo
        contexto
        texto
        tipo
      }
      respuesta {
        paginaActual
        cantidadRegistrosPorPagina
        totalPaginas
        totalRegistros
        registros {
          codigo
          rut_empresa
          sucursal_codigo
          rut_usuario_responsable
          bodega_codigo
          bodega_nombre
          estado_inventario_codigo
          estado_inventario_nombre
          fecha_creacion
          fecha_cierre
          observacion
          no_inventariado
        }
      }
    }
  }
}
        `;
export class InventarioFisicoService {
    constructor(gqlclient, apollo) {
        this.gqlclient = gqlclient;
        this.apollo = apollo;
        this.clientesDataSubject = new BehaviorSubject(null);
        this.Clientess$ = this.clientesDataSubject.asObservable();
    }
    //* DEVUELVE OBSERVABLE CON LA RESPUESTA DE LA QUERY
    getInventarioFisico(inputParams) {
        this.postsQuery = this.apollo.watchQuery({
            query: QUERY_clientes_registros,
            variables: inputParams,
            fetchPolicy: 'network-only'
        });
        this.queryCliente = this.postsQuery.valueChanges.pipe(take(1), pluck('data', 'inventario_fisico'), withLatestFrom(this.Clientess$), tap(([apiResponse, respuesta]) => {
            return apiResponse.obtenerSegunFiltro.respuesta;
        }));
    }
    obtenerSegunFiltro(inputParams, callback) {
        this.gqlclient.query({
            query: gql `
        query ($entidad: inventario_fisicoInputType, $paginaActual: Int, $cantidadRegistrosPorPagina: Int) {
          inventario_fisico {
            obtenerSegunFiltro(filtro: {exacto: $entidad}, paginaActual: $paginaActual, cantidadRegistrosPorPagina: $cantidadRegistrosPorPagina) {
              mensajes {
                codigo
                contexto
                texto
                tipo
              }
              respuesta {
                paginaActual
                cantidadRegistrosPorPagina
                totalPaginas
                totalRegistros
                registros {
                  codigo
                  rut_empresa
                  sucursal_codigo
                  rut_usuario_responsable
                  bodega_codigo
                  bodega_nombre
                  estado_inventario_codigo
                  estado_inventario_nombre
                  fecha_creacion
                  fecha_cierre
                  observacion
                  no_inventariado
                }
              }
            }
          }
        }
        `,
            variables: inputParams,
            fetchPolicy: 'no-cache',
        }, function (response) {
            const { mensajes, respuesta } = response.data.inventario_fisico.obtenerSegunFiltro;
            callback({ mensajes, respuesta });
        });
    }
    guardarInventarioFisico(inputParams, callback) {
        this.gqlclient.mutate({
            mutation: gql `
        mutation ($entidad: inventario_fisicoInputType) {
          inventario_fisico {
            guardarInventarioFisico(entidad: $entidad) {
              mensajes {
                codigo
                contexto
                texto
                tipo
              }
              respuesta {
                codigo
                rut_empresa
                sucursal_codigo
                rut_usuario_responsable
                bodega_codigo
                estado_inventario_codigo
                fecha_creacion
                fecha_cierre
                detalleInventarioFisico {
                  rut_empresa
                  sucursal_codigo
                  inventario_fisico_codigo
                  producto_codigo
                  formato_codigo
                  cantidad_contada
                  cantidad_diferencia
                  cantidad_saldo
                  fecha_registro
                }
              }
            }
          }
        }
        `,
            variables: inputParams,
            fetchPolicy: 'no-cache',
        }, function (response) {
            const { mensajes, respuesta } = response.data.inventario_fisico.guardarInventarioFisico;
            callback({ mensajes, respuesta });
        });
    }
    obtenerInventarFisico(inputParams, callback) {
        this.gqlclient.query({
            query: gql `
        query ($entidad: inventario_fisicoInputType) {
          inventario_fisico {
            obtenerInventarFisico(entidad: $entidad) {
              mensajes {
                codigo
                contexto
                texto
                tipo
              }
              respuesta {
                codigo
                rut_empresa
                sucursal_codigo
                rut_usuario_responsable
                bodega_codigo
                bodega_nombre
                estado_inventario_codigo
                fecha_creacion
                observacion
                no_inventariado
                detalleInventarioFisico {
                  rut_empresa
                  sucursal_codigo
                  inventario_fisico_codigo
                  producto_codigo
                  sku
                  producto_nombre
                  formato_codigo
                  formato_nombre
                  bodega_codigo
                  bodega_nombre
                  rubro_codigo
                  rubro_nombre
                  familia_codigo
                  familia_nombre
                  fecha_registro
                  cantidad_contada
                  saldo_actual
                }
              }
            }
          }
        }
        `,
            variables: inputParams,
            fetchPolicy: 'no-cache',
        }, function (response) {
            const { mensajes, respuesta } = response.data.inventario_fisico.obtenerInventarFisico;
            callback({ mensajes, respuesta });
        });
    }
    guardaWorkInventarioProceso(inputParams, callback) {
        this.gqlclient.mutate({
            mutation: gql `
        mutation ($entidad: inventario_fisicoInputType) {
          inventario_fisico {
            guardaWorkInventarioProceso(entidad: $entidad) {
              mensajes {
                codigo
                contexto
                texto
                tipo
              }
              respuesta {
                codigo
                rut_empresa
                sucursal_codigo
                rut_usuario_responsable
                bodega_codigo
                estado_inventario_codigo
                observacion
                no_inventariado
                detalleWorkInventario {
                  empresa_rut
                  sucursal_codigo
                  inventario_fisico_codigo
                  producto_codigo
                  formato_codigo
                  cantidad_contada
                  fecha_registro
                }
              }
            }
          }
        }
        `,
            variables: inputParams,
            fetchPolicy: 'no-cache',
        }, function (response) {
            const { mensajes, respuesta } = response.data.inventario_fisico.guardaWorkInventarioProceso;
            callback({ mensajes, respuesta });
        });
    }
    excelDocInventarioFisico(inputParams, callback) {
        this.gqlclient.query({
            query: gql `
        query ($entidad: inventario_fisicoInputType) {
          inventario_fisico {
            excelDocInventarioFisico(entidad: $entidad) {
              mensajes {
                codigo
                contexto
                texto
                tipo
              }
              respuesta {
                rutaArchivo
              }
            }
          }
        }
        `,
            variables: inputParams,
            fetchPolicy: 'no-cache',
        }, function (response) {
            const { mensajes, respuesta } = response.data.inventario_fisico.excelDocInventarioFisico;
            callback({ mensajes, respuesta });
        });
    }
    excelDocTomaInventarioFisico(inputParams, callback) {
        this.gqlclient.query({
            query: gql `
        query ($entidad: inventario_fisicoInputType) {
          inventario_fisico {
            excelDocTomaInventarioFisico(entidad: $entidad) {
              mensajes {
                codigo
                contexto
                texto
                tipo
              }
              respuesta {
                rutaArchivo
              }
            }
          }
        }
        `,
            variables: inputParams,
            fetchPolicy: 'no-cache',
        }, function (response) {
            const { mensajes, respuesta } = response.data.inventario_fisico.excelDocTomaInventarioFisico;
            callback({ mensajes, respuesta });
        });
    }
    eliminarInventarioFisico(inputParams, callback) {
        this.gqlclient.mutate({
            mutation: gql `
        mutation ($entidad: inventario_fisicoInputType) {
          inventario_fisico {
            eliminarInventarioFisico(entidad: $entidad) {
              mensajes {
                codigo
                contexto
                texto
                tipo
              }
              respuesta {
                codigo
                rut_empresa
                sucursal_codigo
                rut_usuario_responsable
                bodega_codigo
                estado_inventario_codigo
                fecha_creacion
                fecha_cierre
                detalleInventarioFisico {
                  rut_empresa
                  sucursal_codigo
                  inventario_fisico_codigo
                  producto_codigo
                  formato_codigo
                  cantidad_contada
                  cantidad_diferencia
                  cantidad_saldo
                  fecha_registro
                }
              }
            }
          }
        }
        `,
            variables: inputParams,
            fetchPolicy: 'no-cache',
        }, function (response) {
            const { mensajes, respuesta } = response.data.inventario_fisico.eliminarInventarioFisico;
            callback({ mensajes, respuesta });
        });
    }
    editarInventarioFisico(inputParams, callback) {
        this.gqlclient.mutate({
            mutation: gql `
        mutation ($entidad: inventario_fisicoInputType) {
          inventario_fisico {
            editarInventarioFisico(entidad: $entidad) {
              mensajes {
                codigo
                contexto
                texto
                tipo
              }
              respuesta {
                codigo
                rut_empresa
                sucursal_codigo
                rut_usuario_responsable
                bodega_codigo
                estado_inventario_codigo
                fecha_creacion
                fecha_cierre
                detalleInventarioFisico {
                  rut_empresa
                  sucursal_codigo
                  inventario_fisico_codigo
                  producto_codigo
                  formato_codigo
                  cantidad_contada
                  cantidad_diferencia
                  cantidad_saldo
                  fecha_registro
                }
              }
            }
          }
        }
        `,
            variables: inputParams,
            fetchPolicy: 'no-cache',
        }, function (response) {
            const { mensajes, respuesta } = response.data.inventario_fisico.editarInventarioFisico;
            callback({ mensajes, respuesta });
        });
    }
    obtenerTomaInventario(inputParams, callback) {
        this.gqlclient.query({
            query: gql `
        query ($entidad: inventario_fisicoInputType) {
          inventario_fisico {
            obtenerTomaInventario(entidad: $entidad) {
              mensajes {
                codigo
                contexto
                texto
                tipo
              }
              respuesta {
                codigo
                rut_empresa
                sucursal_codigo
                rut_usuario_responsable
                bodega_codigo
                bodega_nombre
                estado_inventario_codigo
                estado_inventario_nombre
                fecha_creacion
                observacion
                no_inventariado
                detalleInventarioFisico{
                  rut_empresa
                  sucursal_codigo
                  inventario_fisico_codigo
                  producto_codigo
                  sku
                  producto_nombre
                  formato_codigo
                  formato_nombre
                  bodega_codigo
                  bodega_nombre
                  rubro_codigo
                  rubro_nombre
                  familia_codigo
                  familia_nombre
                  fecha_registro
                  cantidad_saldo
                  cantidad_contada
                  cantidad_diferencia
                  precio_costo
                  valor_dif
                }
              }
            }
          }
        }
        `,
            variables: inputParams,
            fetchPolicy: 'no-cache',
        }, function (response) {
            const { mensajes, respuesta } = response.data.inventario_fisico.obtenerTomaInventario;
            callback({ mensajes, respuesta });
        });
    }
    obtenerEditarAjusteFisico(inputParams, callback) {
        this.gqlclient.query({
            query: gql `
        query ($entidad: inventario_fisicoInputType) {
          inventario_fisico {
            obtenerEditarAjusteFisico(entidad: $entidad) {
              mensajes {
                codigo
                contexto
                texto
                tipo
              }
              respuesta {
                codigo
                rut_empresa
                sucursal_codigo
                rut_usuario_responsable
                bodega_codigo
                bodega_nombre
                estado_inventario_codigo
                estado_inventario_nombre
                fecha_creacion
                observacion
                no_inventariado
                detalleInventarioFisico{
                  rut_empresa
                  sucursal_codigo
                  inventario_fisico_codigo
                  producto_codigo
                  sku
                  producto_nombre
                  formato_codigo
                  formato_nombre
                  bodega_codigo
                  bodega_nombre
                  rubro_codigo
                  rubro_nombre
                  familia_codigo
                  familia_nombre
                  fecha_registro
                  cantidad_saldo
                  cantidad_contada
                  cantidad_diferencia
                  precio_costo
                  valor_dif
                }
              }
            }
          }
        }
        `,
            variables: inputParams,
            fetchPolicy: 'no-cache',
        }, function (response) {
            const { mensajes, respuesta } = response.data.inventario_fisico.obtenerEditarAjusteFisico;
            callback({ mensajes, respuesta });
        });
    }
    modificarWorkInventarioProceso(inputParams, callback) {
        this.gqlclient.mutate({
            mutation: gql `
        mutation ($entidad: inventario_fisicoInputType) {
          inventario_fisico {
            modificarWorkInventarioProceso(entidad: $entidad) {
              mensajes {
                codigo
                contexto
                texto
                tipo
              }
              respuesta {
                codigo
                rut_empresa
                sucursal_codigo
                rut_usuario_responsable
                bodega_codigo
                estado_inventario_codigo
                observacion
                no_inventariado
                detalleWorkInventario {
                  empresa_rut
                  sucursal_codigo
                  inventario_fisico_codigo
                  producto_codigo
                  formato_codigo
                  cantidad_contada
                  fecha_registro
                }
              }
            }
          }
        }
        `,
            variables: inputParams,
            fetchPolicy: 'no-cache',
        }, function (response) {
            const { mensajes, respuesta } = response.data.inventario_fisico.modificarWorkInventarioProceso;
            callback({ mensajes, respuesta });
        });
    }
    guardarAjusteInventarioFisico(inputParams, callback) {
        this.gqlclient.mutate({
            mutation: gql `
        mutation ($entidad: inventario_fisicoInputType) {
          inventario_fisico {
            guardarAjusteInventarioFisico(entidad: $entidad) {
              mensajes {
                codigo
                contexto
                texto
                tipo
              }
              respuesta {
                codigo
                rut_empresa
                sucursal_codigo
                rut_usuario_responsable
                bodega_codigo
                bodega_nombre
                estado_inventario_codigo
                fecha_creacion
                fecha_cierre
                detalleInventarioFisico {
                  rut_empresa
                  sucursal_codigo
                  inventario_fisico_codigo
                  producto_codigo
                  sku
                  producto_nombre
                  formato_codigo
                  formato_nombre
                  bodega_codigo
                  bodega_nombre
                  rubro_codigo
                  rubro_nombre
                  familia_codigo
                  familia_nombre
                  fecha_registro
                  cantidad_saldo
                  cantidad_contada
                  cantidad_diferencia
                }
              }
            }
          }
        }
        `,
            variables: inputParams,
            fetchPolicy: 'no-cache',
        }, function (response) {
            const { mensajes, respuesta } = response.data.inventario_fisico.guardarAjusteInventarioFisico;
            callback({ mensajes, respuesta });
        });
    }
    obtenerConsultaInventarioFisico(inputParams, callback) {
        this.gqlclient.query({
            query: gql `
        query ($entidad: inventario_fisicoInputType) {
          inventario_fisico {
            obtenerConsultaInventarioFisico(entidad: $entidad) {
              mensajes {
                codigo
                contexto
                texto
                tipo
              }
              respuesta {
                codigo
                rut_empresa
                sucursal_codigo
                rut_usuario_responsable
                bodega_codigo
                bodega_nombre
                estado_inventario_codigo
                estado_inventario_nombre
                fecha_creacion
                observacion
                no_inventariado
                detalleInventarioFisico {
                  rut_empresa
                  sucursal_codigo
                  inventario_fisico_codigo
                  producto_codigo
                  sku
                  producto_nombre
                  formato_codigo
                  formato_nombre
                  bodega_codigo
                  bodega_nombre
                  rubro_codigo
                  rubro_nombre
                  familia_codigo
                  familia_nombre
                  fecha_registro
                  cantidad_saldo
                  cantidad_contada
                  cantidad_diferencia
                  cant_ent
                  cant_sal
                  precio_costo
                  valor_dif
                }
              }
            }
          }
        }
        `,
            variables: inputParams,
            fetchPolicy: 'no-cache',
        }, function (response) {
            const { mensajes, respuesta } = response.data.inventario_fisico.obtenerConsultaInventarioFisico;
            callback({ mensajes, respuesta });
        });
    }
    obtenerConsultaInventarioFisicoExcel(inputParams, callback) {
        this.gqlclient.query({
            query: gql `
        query ($entidad: inventario_fisicoInputType) {
          inventario_fisico {
            obtenerConsultaInventarioFisico(entidad: $entidad) {
              mensajes {
                codigo
                contexto
                texto
                tipo
              }
              respuesta {
               rutaArchivo
              }
            }
          }
        }
        `,
            variables: inputParams,
            fetchPolicy: 'no-cache',
        }, function (response) {
            const { mensajes, respuesta } = response.data.inventario_fisico.obtenerConsultaInventarioFisico;
            callback({ mensajes, respuesta });
        });
    }
}
InventarioFisicoService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function InventarioFisicoService_Factory() { return new InventarioFisicoService(i0.ɵɵinject(i1.GraphQLClient), i0.ɵɵinject(i2.Apollo)); }, token: InventarioFisicoService, providedIn: "root" });
